//Componente para la imagen del header
const styles = {
  imageWrapper: {
    position: "relative",
    overflow: "hidden",
  },
  image: {
    width: "100%",
    objectFit: "cover",
    objectPosition: "center",
    minHeight: "200px",
    maxHeight: "40%",
    display: "block",
  },
};

function ImageHeader({ route, alt }) {
  
  return (
    <div style={styles.imageWrapper}>
      <img src={route} alt={alt} style={styles.image} className="h-md-auto h-30"/>
    </div>
  );
}
export default ImageHeader;